module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQlJREFUeNpiZEADrOwcCkAqH4gNoBgELkDxxN8/fzxgwAWAmvuB+D8B3I+shxFJ834g5cBAHLgAdIkhiMEMsxlIRSCr0NfXY5CQEGd4+fIlNgMkmFlYBP79/bOTCernAnQVAvwCDLt37QIbhAMUgPQyQQMMKxDg5ydkSD0TIX8TMMSACSmqyDEEbABFAGTAA2IUpqSmMly8eAld+AHIgAOENacxbNq0GZvUAZABC/Fpbm5pZVi0eDEu6YXMwMTwAJgoQAGpgSyjIC8PpktKS3FpPgBMjY2M0JQoAKT2ExMjSJnLEWjAB3AsgBggAWLCA6rGEaoHa450AOL1QPweKQe+h4phJDqAAAMA1QJcJpS0FEgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/sendDetailsBlack.png
// module id = 1016
// module chunks = 0